"use client";

import { useMemo } from "react";
import { iconContentToDataUrl } from "@/lib/custom-indicators/icon";

interface CustomIndicatorAssetPreviewProps {
  path: string;
  content: string;
}

export default function CustomIndicatorAssetPreview({
  path,
  content,
}: CustomIndicatorAssetPreviewProps) {
  const dataUrl = useMemo(() => {
    try {
      return iconContentToDataUrl(path, content);
    } catch {
      return null;
    }
  }, [path, content]);

  if (!dataUrl) {
    return (
      <div className="flex h-full items-center justify-center p-6 text-sm text-muted-foreground">
        Unable to preview this asset.
      </div>
    );
  }

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-6">
      <img
        src={dataUrl}
        alt="Indicator icon preview"
        className="max-h-48 max-w-48 rounded-xl border border-border bg-muted/20 object-contain p-4 shadow-sm"
      />
      <p className="text-xs text-muted-foreground font-mono">{path}</p>
    </div>
  );
}
